import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { toast } from "sonner";
import { UploadCloud, Trash2, Copy } from "lucide-react";

export default function MediaLibrary() {
  const [items, setItems] = useState(null);
  const [uploading, setUploading] = useState(false);

  const load = () => client.get("/admin/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 3 * 1024 * 1024) { toast.error("Image too large (max 3MB)."); return; }
    setUploading(true);
    const reader = new FileReader();
    reader.onload = async () => {
      try { await client.post("/admin/upload", { data: reader.result }); toast.success("Uploaded to Media Library"); load(); }
      catch { toast.error("Upload failed"); }
      setUploading(false);
    };
    reader.readAsDataURL(file);
  };

  const del = async (id) => {
    if (!window.confirm("Delete this media file?")) return;
    await client.delete(`/admin/media/${id}`);
    toast.success("Media deleted");
    load();
  };

  const copy = (url) => { navigator.clipboard?.writeText(url); toast.success("Image URL copied"); };

  return (
    <div data-testid="admin-media">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-head font-bold text-3xl uc">Media Library</h1>
        <label className="bg-r24-red text-white font-bold uc text-sm px-5 py-2.5 cursor-pointer flex items-center gap-2 hover:bg-r24-reddark">
          <UploadCloud size={18} /> {uploading ? "Uploading…" : "Upload Image"}
          <input type="file" accept="image/*" onChange={upload} className="hidden" data-testid="media-upload" />
        </label>
      </div>

      {!items ? <p>Loading…</p> : items.length === 0 ? (
        <p className="text-gray-500" data-testid="media-empty">No media uploaded yet. Upload an image to build your library.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((m) => (
            <div key={m.id} className="bg-white border border-gray-200 group" data-testid={`media-${m.id}`}>
              <div className="aspect-video bg-gray-100 overflow-hidden">
                <img src={m.data} alt="" className="w-full h-full object-cover" />
              </div>
              <div className="flex justify-between p-2">
                <button onClick={() => copy(m.data)} className="text-gray-500 hover:text-black" title="Copy URL"><Copy size={15} /></button>
                <button onClick={() => del(m.id)} className="text-r24-red" title="Delete" data-testid={`media-delete-${m.id}`}><Trash2 size={15} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
